export default __webpack_public_path__ + "static/media/stroke1.46b83d43.png";